<template>
  <v-card flat>
    <v-card-text>
      <div>
        <div class="caption">Event category</div>
        <p class="primary--text ma-0">{{ value.category || '-' }}</p>
      </div>
      <div class="mt-2">
        <div class="caption">Event action</div>
        <p class="primary--text ma-0">{{ value.action || '-' }}</p>
      </div>
      <div class="mt-2">
        <div class="caption">Event label</div>
        <p class="primary--text ma-0">{{ value.label || '-' }}</p>
      </div>
      <div class="mt-2">
        <div class="caption">Event value</div>
        <p class="primary--text ma-0">{{ value.value || '-' }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/EventTracking.vue